import Helpers from "utils/Helpers"
import { ReimbursementsListDeductibleString } from "components/views/reimbursements/reimbursementsList/ReimbursementsListDeductibleString"
import React, { FC } from "react"
import { Reimbursement } from "types/reimbursement"
import L10n from "lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

type ReimbursementsListPaidStatusProps = {
  reimbursement: Reimbursement
}

const ReimbursementsListPaidStatus: FC<ReimbursementsListPaidStatusProps> = ({
  reimbursement
}: ReimbursementsListPaidStatusProps) => {
  const formattedPaidDateTime = Helpers.formatDate(reimbursement.paidDatetime, "MMM DD")

  return (
    <>
      {reimbursement.amount > 0 && l`Reimbursed on ` + formattedPaidDateTime}
      <br />
      <ReimbursementsListDeductibleString reimbursement={reimbursement} />
    </>
  )
}

export { ReimbursementsListPaidStatus }
